import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElectronComponent } from './simple-icons-electron.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElectronComponent ],
    exports:      [ SimpleIconsElectronComponent ],
    bootstrap:    []
})
export class SimpleIconsElectronModule {}
